import axios from "axios"
export function getApplicantData(token, userId) {
    return axios.get(process.env.REACT_APP_API_URL + `/getApplicantData?userId=${userId}`, {
        headers: {
            'Authorization': `${token}`
        }
    });
}